import React, {Component} from 'react';
import './TermOfUse.css';

import {getContactEmailAddress} from "../utils/methods";

class TermOfUse extends Component {
	componentDidMount() {
		// Scroll to top when component mounts
		window.scrollTo(0, 0);
	}

	render() {
		return (
			<div className="z-tou-container">
				<div className="z-tou-content">
					<h1>TERMS OF USE - ZWORLD METAVERSE</h1>

					<section>
						<h2>1. ACCEPTANCE OF TERMS</h2>
						<p>By downloading, installing, or using Zworld Metaverse mobile shooting game (the "Game"), you agree to be bound by these Terms of Use. If you do not agree to these terms, do not download, install, or use the Game.</p>
					</section>

					<section>
						<h2>2. LICENSE</h2>
						<p>We grant you a limited, non-exclusive, non-transferable, revocable license to use Zworld Metaverse for your personal, non-commercial entertainment purposes on compatible mobile devices.</p>
					</section>

					<section>
						<h2>3. USER CONDUCT</h2>
						<p>You agree not to:</p>
						<ul>
							<li>Use cheats, automation software, hacks, mods, or any unauthorized third-party software</li>
							<li>Exploit bugs or engage in activities that disrupt gameplay for others</li>
							<li>Create unfair advantages in shooting competitions or matchmaking</li>
							<li>Use Zworld Metaverse for any illegal purpose or in violation of any laws</li>
							<li>Harass, threaten, or harm other players through in-game communication</li>
							<li>Share your account credentials with others or sell/transfer your account</li>
							<li>Impersonate other players or staff members</li>
						</ul>
					</section>

					<section>
						<h2>4. USER CONTENT</h2>
						<p>Any content you create, customize, or share through Zworld Metaverse remains your intellectual property, but you grant us a worldwide license to use, reproduce, modify, and distribute such content in connection with the Game.</p>
					</section>

					<section>
						<h2>5. VIRTUAL ITEMS AND CURRENCY</h2>
						<ul>
							<li>Virtual items and currency are licensed, not sold, and have no monetary value</li>
							<li>Purchases are final and non-refundable except where required by law</li>
							<li>We reserve the right to manage, modify or eliminate virtual items and currency</li>
							<li>Unauthorized buying, selling, or trading of accounts or virtual items is prohibited</li>
						</ul>
					</section>

					<section>
						<h2>6. PRIVACY</h2>
						<p>Your use of Zworld Metaverse is also governed by our Privacy Policy, which describes how we collect, use, and share your information across the mobile platform.</p>
					</section>

					<section>
						<h2>7. UPDATES AND MODIFICATIONS</h2>
						<p>We reserve the right to update, modify, or discontinue Zworld Metaverse or any features at any time. This includes game balance, weapons, maps, and gameplay mechanics to maintain fair gameplay.</p>
					</section>

					<section>
						<h2>8. MOBILE DEVICE USAGE</h2>
						<p>Zworld Metaverse may use device resources including battery, data, and storage. You are responsible for any charges related to data usage, in-app purchases, or subscription services.</p>
					</section>

					<section>
						<h2>9. DISCLAIMERS AND LIMITATIONS OF LIABILITY</h2>
						<p>ZWORLD METAVERSE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE ARE NOT LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES, INCLUDING DAMAGE TO YOUR MOBILE DEVICE OR LOSS OF GAME PROGRESS.</p>
					</section>

					<section>
						<h2>10. TERMINATION</h2>
						<p>We may terminate or suspend your access to Zworld Metaverse immediately without notice for violations of these Terms, including but not limited to cheating, harassment, or using unauthorized third-party software.</p>
					</section>

					<section>
						<h2>11. GOVERNING LAW</h2>
						<p>These Terms shall be governed by and construed in accordance with the laws of the Province of British Columbia, Canada, without regard to its conflict of law principles.</p>
					</section>

					<section>
						<h2>12. CHANGES TO TERMS</h2>
						<p>We may revise these Terms at any time. Your continued use of Zworld Metaverse following the posting of revised Terms means you accept those changes.</p>
					</section>

					<section>
						<h2>13. CONTACT INFORMATION</h2>
						<p>For questions regarding these Terms, please contact us at {getContactEmailAddress}.</p>
					</section>

					<p className="z-tou-last-updated">Last updated: March 13, 2025</p>
				</div>
			</div>
		);
	}
}

export default TermOfUse;